import axios from 'axios';
import { useEffect, useState } from 'react';
import {app} from '../config'
import { getTokenfromUserObj } from '../utils/getTokenfromObj';
const getPrayerById = (id) => {
    let reqid=id
    const [loading, setLoading] = useState(true);
    const [response, setResponse] = useState(null);
    const [error, setError] = useState(null);
    const token=getTokenfromUserObj()
    useEffect(() => {
        const getPrayer = async (id) => {
          try {
            const res = await axios.get(`${app.URL}/prayertime/view/${id}`,{headers:{auth:token}});
            console.log(res);
            setResponse(res.data);
            setLoading(false);
          } catch (err) {
            setError(err);
            setLoading(false);
          }
        };
        getPrayer(reqid);
      }, []);
    
      return { loading, response, error };
    };
export default getPrayerById